import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-insight-egrc-authoring-tools',
  templateUrl: './insight-egrc-authoring-tools.component.html',
  styleUrls: ['./insight-egrc-authoring-tools.component.scss']
})
export class InsightEgrcAuthoringToolsComponent {
  constructor(private router: Router) {}
  sidebarActive: boolean = true;
}
